module.exports = __webpack_public_path__ + "media/images/app/products/index/types/bracelets-mobile-ac99b12e8c6bc7c5d4461338eb121c4b.webp";